import { getTargetOrigin } from './redirectRouteToDomain';

const targetOriginSuffixes = {
  'ar-AE': 'ae.fashionunited.com',
  'ar-DZ': 'dz.fashionunited.com',
  'ar-EG': 'eg.fashionunited.com',
  'ar-JO': 'jo.fashionunited.com',
  'ar-LB': 'lb.fashionunited.com',
  'ar-MA': 'ma.fashionunited.com',
  'ar-SA': 'sa.fashionunited.com',
  'ar-TN': 'tn.fashionunited.com',
  'az-AZ': 'az.fashionunited.com',
  'bg-BG': 'bg.fashionunited.com',
  'bn-BD': 'bd.fashionunited.com',
  'cs-CZ': 'fashionunited.cz',
  'da-DK': 'fashionunited.dk',
  'de-AT': 'fashionunited.at',
  'de-CH': 'fashionunited.ch',
  'de-DE': 'fashionunited.de',
  'el-CY': 'cy.fashionunited.com',
  'el-GR': 'gr.fashionunited.com',
  'en-AU': 'au.fashionunited.com',
  'en-CA': 'fashionunited.ca',
  'en-GB': 'fashionunited.uk',
  'en-GH': 'gh.fashionunited.com',
  'en-IE': 'fashionunited.ie',
  'en-IN': 'fashionunited.in',
  'en-NG': 'ng.fashionunited.com',
  'en-NZ': 'fashionunited.nz',
  'en-SG': 'sg.fashionunited.com',
  'en-US': 'fashionunited.com',
  'en-ZA': 'za.fashionunited.com',
  'es-AR': 'fashionunited.com.ar',
  'es-BO': 'bo.fashionunited.com',
  'es-CL': 'fashionunited.cl',
  'es-CO': 'fashionunited.co',
  'es-CR': 'cr.fashionunited.com',
  'es-DO': 'do.fashionunited.com',
  'es-EC': 'ec.fashionunited.com',
  'es-ES': 'fashionunited.es',
  'es-GT': 'gt.fashionunited.com',
  'es-HN': 'hn.fashionunited.com',
  'es-MX': 'fashionunited.mx',
  'es-PA': 'pa.fashionunited.com',
  'es-PE': 'fashionunited.com.pe',
  'es-PR': 'pr.fashionunited.com',
  'es-PY': 'py.fashionunited.com',
  'es-SV': 'sv.fashionunited.com',
  'es-UY': 'uy.fashionunited.com',
  'es-VE': 've.fashionunited.com',
  'et-EE': 'ee.fashionunited.com',
  'fi-FI': 'fashionunited.fi',
  'fil-PH': 'ph.fashionunited.com',
  'fr-BE': 'fashionunited.be',
  'fr-CA': 'fashionunited.ca',
  'fr-CH': 'fashionunited.ch',
  'fr-CI': 'ci.fashionunited.com',
  'fr-FR': 'fashionunited.fr',
  'fr-LU': 'fashionunited.lu',
  'fr-SN': 'sn.fashionunited.com',
  'he-IL': 'il.fashionunited.com',
  'hr-HR': 'hr.fashionunited.com',
  'hu-HU': 'fashionunited.hu',
  'id-ID': 'id.fashionunited.com',
  'it-CH': 'fashionunited.ch',
  'it-IT': 'fashionunited.it',
  'ja-JP': 'fashionunited.jp',
  'ka-GE': 'ge.fashionunited.com',
  'kk-KZ': 'kz.fashionunited.com',
  'km-KH': 'kh.fashionunited.com',
  'ko-KR': 'kr.fashionunited.com',
  'lt-LT': 'lt.fashionunited.com',
  'lv-LV': 'lv.fashionunited.com',
  'mg-MG': 'mg.fashionunited.com',
  'ms-MY': 'my.fashionunited.com',
  'mt-MT': 'mt.fashionunited.com',
  'nb-NO': 'fashionunited.no',
  'ne-NP': 'np.fashionunited.com',
  'nl-BE': 'fashionunited.be',
  'nl-NL': 'fashionunited.nl',
  'pl-PL': 'fashionunited.pl',
  'pt-BR': 'fashionunited.com.br',
  'pt-PT': 'fashionunited.pt',
  'ro-RO': 'ro.fashionunited.com',
  'ru-RU': 'ru.fashionunited.com',
  'si-LK': 'lk.fashionunited.com',
  'sk-SK': 'sk.fashionunited.com',
  'sl-SI': 'si.fashionunited.com',
  'sr-RS': 'rs.fashionunited.com',
  'sv-SE': 'fashionunited.se',
  'sw-KE': 'ke.fashionunited.com',
  'th-TH': 'th.fashionunited.com',
  'tr-TR': 'fashionunited.com.tr',
  'uk-UA': 'ua.fashionunited.com',
  'ur-PK': 'pk.fashionunited.com',
  'uz-UZ': 'uz.fashionunited.com',
  'vi-VN': 'vn.fashionunited.com',
  'zh-CN': 'cn.fashionunited.com',
  'zh-HK': 'fashionunited.hk',
  'zh-TW': 'tw.fashionunited.com',
};

const getOriginByLocale = (sourceOrigin, locale) => getTargetOrigin(
  sourceOrigin,
  targetOriginSuffixes[locale],
);

export default getOriginByLocale;
